import { activeAppVariant } from '../appVariant'

const sharedMqttConfig = {
  subscriptions: [
    'message/+/scan'
  ],
  enabledHandlers: {
    scan: true,
    diagnose: false,
    properties: false,
    heartBeat: false,
    logFiles: false,
    getLog: false,
    screenShot: false,
    alarm: false
  }
}

const supervisoryOnlyMqttConfig = {
  subscriptions: [
    'message/+/diagnose',
    'message/+/properties',
    'message/+/heartBeat',
    'message/+/logFiles',
    'message/+/getLog',
    'message/+/screenShot',
    'alarm/+'
  ],
  enabledHandlers: {
    diagnose: true,
    properties: true,
    heartBeat: true,
    logFiles: true,
    getLog: true,
    screenShot: true,
    alarm: true
  }
}

const mergeMqttConfig = function (...configs) {
  return configs.reduce((mergedConfig, config) => {
    return {
      subscriptions: mergedConfig.subscriptions.concat(config.subscriptions),
      enabledHandlers: {
        ...mergedConfig.enabledHandlers,
        ...config.enabledHandlers
      }
    }
  }, {
    subscriptions: [],
    enabledHandlers: {}
  })
}

const variantMqttConfigs = {
  ads: mergeMqttConfig(sharedMqttConfig),
  supervisory: mergeMqttConfig(sharedMqttConfig, supervisoryOnlyMqttConfig)
}

export const activeMqttConfig = variantMqttConfigs[activeAppVariant.name] || variantMqttConfigs.ads
export const mqttConfigByVariant = variantMqttConfigs
